import React from 'react'
import StaticQuestionSlide from '../slides/StaticQuestionSlide'
import {processQuestionResponses} from '../../utils/processQuestionResponses'
import {Motion, spring} from 'react-motion'
import LiveViewMainStudentList from './LiveViewMainStudentList'
import filter from 'lodash/filter'
 
const springConfig = {stiffness: 170, damping: 26}


class LiveViewMain extends React.PureComponent{	



	render(){


		const {currentPollId,currentSetPollId,currentSetPollPollId,layout,section,isScan, showGraph, showCorrect,isReviewScreen,poll,isSurvey,liveViewSettings} = this.props



		const students=filter(section.students,{archived:false})


		let showStudentList

		if(liveViewSettings.studentListVisible === 'always'){
			showStudentList = true			
		}
		else if(liveViewSettings.studentListVisible === 'never'){
			showStudentList = false
		}
		else if(liveViewSettings.studentListVisible === 'scan'){
			showStudentList = isScan
		}

		const slideScanTransitionStyle = showStudentList
	    ? { //when displayed
	       	yTranslate: spring(layout.yPosScanTranslate, springConfig),
	       	xTranslate: spring(layout.xPosScanTranslate, springConfig),
	       	scale: spring(layout.scanSlideScale, springConfig),     			       	
	      }
	    : { //when not displayed
	  			yTranslate: spring(0, springConfig),
	  			xTranslate: spring(0, springConfig),
	  			scale: spring(1, springConfig),
	      }


		const slideScanStudentListStyle = showStudentList
	    ? { //when displayed
	       	xTranslate: spring(0, springConfig),
	       	opacity: spring(1, springConfig),
	      }
	    : { //when not displayed
    			xTranslate: spring(layout.studentListxPosScanTranslate, springConfig),
    			opacity: spring(0, springConfig),
	      }

		//

	  let studentLetterBlockSideDimension
	  if(layout){		  	
	  	studentLetterBlockSideDimension = layout.studentListItemHeight - layout.studentListItemPillMargin - layout.studentListItemPillMargin
		}

		//

		
 		let processedResponses

	 	if(poll && this.props.section && poll.hasResponses ){
	 		processedResponses=processQuestionResponses(poll,this.props.section)			
	 	}

		 
		let studentSortOrder='displayName'
 		if(liveViewSettings.studentSortOrder ==='card'){
 			studentSortOrder='card'
 		}
 		const {showStudentCardNumbers,alwaysShowLetterblock,colorScheme,showResponseCounts}=liveViewSettings
				
		const isScanScreen = isScan
		const isReviewOrScan = isReviewScreen || isScanScreen
		const isAskScreen = !isReviewScreen && !isScanScreen

		const lettersArray=['A','B','C','D']
		let correctLetters=[]
		
		if(poll&&poll.snapshot){
			poll.snapshot.choices.map((choice,index) => {
				if(choice.correct===true){
					const correctLetter=lettersArray[index]
					correctLetters.push(correctLetter)
				}
				return null
			})	
		}

		let key=''
		if(currentPollId){
			key=currentPollId
		}else if(currentSetPollId && currentSetPollPollId){
			key=`${currentSetPollId}_${currentSetPollPollId}`
		}

		return(
			<React.Fragment> 
				
				<Motion style={slideScanTransitionStyle}>
					{({yTranslate, xTranslate, scale}) =>
						<div 
							onDoubleClick={this.props.handleDoubleClick}
							className='liveView-slide' 
							style={{
								width: `${layout.slideDimensions.width}px`, 
								height: `${layout.slideDimensions.height}px`,
								top: `${layout.yPosSlide}px`,
								left: `${layout.xPosSlide}px`,
								transform: `translateY(${yTranslate}px) translateX(${xTranslate}px) scale(${scale})`,
								transformOrigin: 'top left'
							}}>
								
							{this.props.snapshot &&
								<StaticQuestionSlide 
									showResponseCounts={showResponseCounts}
									alwaysShowLetterblock={alwaysShowLetterblock}
									colorScheme={colorScheme}
									key={key}							 
									question={this.props.snapshot}
									displayWidth={layout.slideDimensions.width}									
									isLiveView={true}
									isAskScreen={isAskScreen}
									isScanScreen={isScanScreen}
									isReviewScreen={isReviewScreen}
									reportView={false}
									isSurvey={isSurvey}									
									showGraph={showGraph}
									showCorrect={showCorrect}
									processedResponses={isReviewOrScan ? processedResponses : null}
									totalResponses={(isReviewOrScan && poll) ? (poll.assignedResponseCount + poll.unassignedResponseCount) : 0	}
									expectedResponses={(isReviewOrScan && poll) ? (students.length + poll.unassignedResponseCount) : 0	}
								/>	
							}
						</div>
					}
				</Motion>
				
				<LiveViewMainStudentList 
					key={key}
					showStudentCardNumbers={showStudentCardNumbers}
					slideScanStudentListStyle={slideScanStudentListStyle}
					colorScheme={colorScheme}
					layout={layout}
					students={students}
					manualShowIndividualStudentResponses={this.props.manualShowIndividualStudentResponses}
					showIndividualStudentResponses={liveViewSettings.showIndividualResponses}
					isAskScreen={isAskScreen}
					showCorrect={showCorrect}
					poll={poll}
					isSurvey={isSurvey}
					correctLetters={correctLetters}
					isScanScreen={isScanScreen}
					studentSortOrder={studentSortOrder}
					studentLetterBlockSideDimension={studentLetterBlockSideDimension}

				/>
						

			</React.Fragment>
		)
	}
}

export default LiveViewMain



// WEBPACK FOOTER //
// ./src/components/liveView/LiveViewMain.js